import { useRouter } from "next/router"

import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"

import pathMap from "./pathMap"
import resolvePath from "./resolvePath"

const useNextRouter = (url: keyof typeof pathMap) => {
  const router = useRouter()
  useMountEffect(() => {
    const as = process.env.NODE_ENV === "production" ? pathMap[url] : undefined
    router.prefetch(url, as)
  })

  return {
    push({ keepQuery = false, ...options }: Parameters<typeof router.push>[2] & { keepQuery?: boolean } = {}) {
      const { href, as } = resolvePath(url, router.query, keepQuery)
      return router.push(href, as, options)
    },
    replace({ keepQuery = false, ...options }: Parameters<typeof router.replace>[2] & { keepQuery?: boolean } = {}) {
      const { href, as } = resolvePath(url, router.query, keepQuery)
      return router.replace(href, as, options)
    },
  }
}

export default useNextRouter
